module.exports = __webpack_public_path__ + "img/koreans-DE.22e04b69.png";